import {isDefined} from '@ls/js-utils';
import scope from './scope';

export default class SecurityAttributeDefinition {
  static getDefault = () => new SecurityAttributeDefinition({
    attribute: 'cusip',
  });

  #attribute;

  constructor(props = {}) {
    const {attribute} = props;
    this.#attribute = attribute;
  }

  copy = () => ({
    attribute: this.#attribute
  });

  get attribute() {
    return this.#attribute;
  }

  get key() {
    return `${scope} - ${this.#attribute}`;
  }

  get complete() {
    return isDefined(this.#attribute);
  }

  setAttribute = (value) => new SecurityAttributeDefinition({
    attribute: value,
  })
}